import { DateString } from "./conversionUtils";

export const digit2Regexp = /^((-?)\d{1,2}?)?$/;
export const digit3Regexp = /^((-?)\d{1,3}?)?$/;
export const digit4Regexp = /^((-?)\d{1,4}?)?$/;
export const digit5Regexp = /^((-?)\d{1,5}?)?$/;
export const digit2_1Regexp = /^((-?)\d{1,2}((,|\.)(\d{1,1}))?)?$/;
export const digit3_2Regexp = /^((-?)\d{1,3}((,|\.)(\d{1,2}))?)?$/;
export const digit7_3Regexp = /^((-?)\d{1,7}((,|\.)(\d{1,3}))?)?$/;
export const digit8_2Regexp = /^((-?)\d{1,8}((,|\.)(\d{1,2}))?)?$/;
export const digit9_1Regexp = /^((-?)\d{1,9}((,|\.)(\d{1}))?)?$/;
export const digit9_3Regexp = /^((-?)\d{1,9}((,|\.)(\d{1,3}))?)?$/;
export const digit9Regexp = /^((-?)\d{1,9}?)?$/;
export const digit10Regexp = /^((-?)\d{1,10}?)?$/;
export const digit10_2Regexp = /^((-?)\d{1,10}((,|\.)(\d{1,2}))?)?$/;

export const positiveDigit1Regexp = /^(\d{1,1}?)?$/;
export const positiveDigit2Regexp = /^(\d{1,2}?)?$/;
export const positiveDigit3Regexp = /^(\d{1,3}?)?$/;
export const positiveDigit4Regexp = /^(\d{1,4}?)?$/;
export const positiveDigit5Regexp = /^(\d{1,5}?)?$/;
export const positiveDigit6Regexp = /^(\d{1,6}?)?$/;
export const positiveDigit2_1Regexp = /^(\d{1,2}((,|\.)(\d{1,1}))?)?$/;
export const positiveDigit3_2Regexp = /^(\d{1,3}((,|\.)(\d{1,2}))?)?$/;
export const positiveDigit5_2Regexp = /^(\d{1,5}((,|\.)(\d{1,2}))?)?$/;
export const positiveDigit7_3Regexp = /^(\d{1,7}((,|\.)(\d{1,3}))?)?$/;
export const positiveDigit8_2Regexp = /^(\d{1,8}((,|\.)(\d{1,2}))?)?$/;
export const positiveDigit9_1Regexp = /^(\d{1,9}((,|\.)(\d{1}))?)?$/;
export const positiveDigit9_3Regexp = /^(\d{1,9}((,|\.)(\d{1,3}))?)?$/;
export const positiveDigit9Regexp = /^(\d{1,9}?)?$/;
export const positiveDigit10Regexp = /^(\d{1,10}?)?$/;
export const positiveDigit10_1Regexp = /^(\d{1,10}((,|\.)(\d{1,1}))?)?$/;
export const positiveDigit10_2Regexp = /^(\d{1,10}((,|\.)(\d{1,2}))?)?$/;

export const positiveNonZeroDigit4Regexp = /^([1-9](\d{1,3}?)?)?$/;

export const cadastralCodeRegexp = /^\d{5}:\d{3}:\d{4}$/;
export const cadastralCodeOrRegPartNrRegexp = /^\d{5}:\d{3}:\d{4}$|^[1-9]\d+$/;
export const personalCodeRegexp = /^[3-6][0-9]{10}$/;
export const organisationCodeRegexp = /^\d{8}$/;

export const contractPath = /^\/lepingud\/\d{1,10}?$/;
export const adsOID = /^\w{10}$/;

export const urlValidationRegexp = /^(https|http|ftp):\/\/.*/;

export const yearRegexp = /^\d{4}$/;
export const monthRegexp = /^(1[0-2]?|[1-9])$/;

export const percentageRegexp = /^(100(?:\.0{1,2})?|\d{1,2}(?:\.\d{1,2})?)?$/;
export const percentageRegexp_comma = /^(100(?:(?:\.|,)0{1,2})?|\d{1,2}(?:(?:\.|,)\d{1,2})?)?$/;

export const phonenumberRegexp = /^(\+?)(\d+)$/;

export const countryRegexp = /^([a-zA-Z]{2,2})$/;

//export const emailRegexp = /^(?!.*\.\.)(?!.*\.@$|^\..*|.*\.$)[A-Za-z0-9+_.-]+@(?![.-])+[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
export const emailRegexp =
  /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

//First non-whitespace must not be spefcial symbol
export const specialSymbolPattern = /^(\s*)(?![=\+@\t!#\$%\^\&\*\)\(\._\-\\\/])(.|\r?\n|\r)*$/; //^(\s*)(?![=\+@\t!#\$%\^\&\*\)\(\._\-\\\/])(.|\n)*$

export function isAllNumeric(input: string) {
  return /^\d+$/.test(input);
}

export function dateInPast(val: DateString) {
  const d1 = new Date(val).setHours(0, 0, 0, 0);
  const d2 = new Date(Date.now()).setHours(0, 0, 0, 0);
  return d1 < d2;
}

export function dateInPastYear(val: DateString) {
  const d1 = new Date(val).getFullYear();
  return yearInPast(d1);
}

export function dateInPastOrPresent(val: DateString) {
  const d1 = new Date(val).setHours(0, 0, 0, 0);
  const d2 = new Date(Date.now()).setHours(0, 0, 0, 0);
  return d1 <= d2;
}

export function dateABeforeB(valA: DateString, valB: DateString) {
  return new Date(valA).setHours(0, 0, 0, 0) <= new Date(valB).setHours(0, 0, 0, 0);
}

export function dateIn30Years() {
  return new Date(new Date().setFullYear(new Date().getFullYear() + 30));
}

export function yearInPast(val: number) {
  const curYear = new Date().getFullYear();
  return val < curYear;
}

export function getCurrentYear() {
  const curYear = new Date().getFullYear();
  return curYear;
}

export function yearABeforeB(valA: number, valB: number) {
  return valA <= valB;
}

export const getOverlapErrorMessage = (
  sinceChanged: boolean,
  untilChanged: boolean,
  sinceField: string,
  untilField: string,
  errMsg: string,
) => {
  const errObj: any = {};
  if (sinceChanged) {
    errObj[sinceField] = errMsg;
  }
  if (untilChanged) {
    errObj[untilField] = errMsg;
  }
  return errObj;
};

// Used to validate ,= and ;= non-existende in string
export function giveCustomCommaValidation(errText: string) {
  return function customCommaValidation(_values: any, value: any) {
    if (typeof value == "string" && (value.includes(",=") || value.includes(";="))) {
      return errText;
    }
    return true;
  };
}
export function customCommaValidation(_values: any, value: any) {
  if (typeof value == "string" && (value.includes(",=") || value.includes(";="))) {
    return false;
  }
  return true;
}
